import Cookie from "js-cookie";
import store from "../../store";

export default async function auth({
  to,
  next
}) {
  const token = Cookie.get("ecs_user_jwt_token") || null;
  const tokenStore = store.getters["auth/token"];
  // const account = store.getters["auth/account"];
  const requiredAuth = to.matched.some(record => record.meta.requiresAuth);
  // const isDev = process.env.NODE_ENV === 'development';
  if (requiredAuth) {
    // if (token && !isDev) {
    //   let cookies = await window.cookieStore.getAll({
    //     domain: 'ecs.fabbi.io'
    //   });
    //   let foundCookies = cookies.find(cookieItem => {
    //      return cookieItem.domain === 'ecs.fabbi.io' || cookieItem.domain === null;
    //   });
    //   if (foundCookies) {
    //     Cookie.remove("ecs_user_jwt_token");
    //   }
    // }
    if (!token && !tokenStore) {
      next({
        name: "Login"
      });
    } else if (token && tokenStore) {
      store.dispatch("commons/getCommonsData");
      store.dispatch("commons/getCountRequest");
      await store.dispatch("auth/accountInfo");
    }
    const account = store.getters["auth/account"];
    if (token
        && account
        && account.department_code
        && (account.department_code != "PR"
        && account.job_title_code != "DIRECTOR"
        && ["new list", "New Create", "New Update"].includes(to.name))
        ) {
          next("/403");
        }

    if (token
        && account
        && account.department_code
        && account.department_code != "PR"
        && account.id != "0038"
        && ["Summer Trip Vote", "Summer Trip Vote Chart"].includes(to.name)) {
          next("/403");
        }
    next();
  } else {
    if (to.name === "Login" && token && tokenStore) {
      next({
        name: "Dashboard"
      });
    }
    next();
  }
  next();
}
